export enum OperationStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
}
